import { render, staticRenderFns } from "./FormInformacaoPessoal.vue?vue&type=template&id=460f8f5d"
import script from "./FormInformacaoPessoal.vue?vue&type=script&lang=js"
export * from "./FormInformacaoPessoal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports